import { useId } from "react";
// Material
import { Box, Divider, Skeleton } from "@mui/material";

export const NotificationsSkeleton = ({ count = 3 }: Readonly<{ count?: number }>) => {
	const id = useId();

	const keys = Array.from({ length: count }, (_, i) => i);

	return (
		<>
			{keys
				.map((key) => `${id}-${key}`)
				.map((key) => (
					<Box key={key}>
						<Box className="h-[74px] pt-[10px] pl-[10px]">
							<Skeleton className="w-[90%]" />
							<Skeleton className="w-[30%]" />
						</Box>
						<Divider />
					</Box>
				))}
		</>
	);
};
